import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SiteListsApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class SiteListsService {
  public apiUrl = 'site-lists';

  constructor(private readonly http: HttpClientService) {}

  public get(): Observable<SiteListsApiModel> {
    return this.http.get<SiteListsApiModel>(`${this.apiUrl}`);
  }
}
